import axios from '../utils/request'
let bestusrl = 'http://api.singschool.cn'

// 主页排行榜
export const ranks = (data) => {
  return axios.post(bestusrl + '/api/game/ranks', data || {})
}
// 获取用户信息
// /api/user / userinfo
export const userinfo = () => {
  return axios.get(bestusrl + '/api/user/userinfo')
}

// 获取登录二维码
export const qrlogin = (data) => {
  return axios.get(bestusrl + '/api/weixin/qrlogin?loginId=' + data)
}
// 检查扫码登录
export const checkLogin = (data) => {
  return axios.get(bestusrl + '/api/weixin/qrlogin/check?loginId=' + data)
}

// 获取验证码
export const getTelCode = (data) => {
  return axios.post(bestusrl + '/api/sms/sendcode', data || {})
}

// 检查验证码是否真确
// /api/sms/validate
export const checkTelCode = (data) => {
  return axios.post(bestusrl + '/api/user/validatephone', data || {})
}

// 获取我的歌单
export const getSongList = (data) => {
  return axios.post(bestusrl + '/usersong/mysongs', data || {})
}
// 上传文件 /api/upload/file
export const uploadFile = (data) => {
  return axios.post(bestusrl + '/api/upload/file', data || {})
}
/// api/song/add/frompc 后台上传歌曲
export const addSong = (data) => {
  return axios.post(bestusrl + '/api/song/add', data || {})
}

// 删除歌曲
export const delSong = (data) => {
  return axios.post(bestusrl + '/api/song/del', data || {})
}
// 歌曲详情
// /usersong/getsongdetails
export const songDetails = (data) => {
  return axios.post(bestusrl + '/usersong/getsongdetails', data || {})
}

// 修改歌曲
export const editSong = (data) => {
  return axios.post(bestusrl + '/api/song/edit', data || {})
}

// 添加助理
export const addmycustomer = (data) => {
  return axios.get(bestusrl + '/api/user/mycustomer', data || {})
}



// WEBPACK FOOTER //
// ./src/api/index.js